import { withErrorBoundary } from "@sentry/nextjs";
import { gql } from "graphql-request";
import { VFC } from "react";
import styled from "styled-components";
import { DataTestId } from "types/enums/testId";
import { Pricing5Content } from "types/graphql/generated";
import { Pricing5BottomSection } from "./components/Pricing5BottomSection";
import { Pricing5MiddleSection } from "./components/Pricing5MiddleSection";
import { Pricing5TopSection } from "./components/Pricing5TopSection";

interface Props {
  content: Pricing5Content;
}

const Pricing5: VFC<Props> = withErrorBoundary(
  ({
    content: {
      pricing5Title,
      pricing5CostGetBackLabel,
      pricing5CostGetBackLink,
      pricing5CostGetBackIcon,
      pricing5Cards,
      pricing5Description,
    },
  }) => {
    return (
      <StyledPricing5>
        <div className="Pricing5__content" data-testid={DataTestId.Pricing5Container}>
          <Pricing5TopSection content={{ pricing5Title, pricing5Description }} />
          <Pricing5MiddleSection
            content={{
              pricing5Cards,
            }}
          />
          {pricing5CostGetBackLabel && (
            <Pricing5BottomSection
              content={{ pricing5CostGetBackLabel, pricing5CostGetBackLink, pricing5CostGetBackIcon }}
            />
          )}
        </div>
      </StyledPricing5>
    );
  },
  {}
);

gql`
  fragment Pricing5Content on ComponentPricingPricing5 {
    pricing5Title
    pricing5Description
    pricing5CostGetBackLabel
    pricing5CostGetBackIcon {
      data {
        image: attributes {
          src: hash
          alt: alternativeText
        }
      }
    }
    pricing5CostGetBackLink
    pricing5Cards {
      pricing5FeatureTag {
        featureTag
        featureTagBackground
        featureTagColor
      }
      pricing5Title {
        tag
        tagBackground
        monthlyPrice
        discountedMonthlyPrice
        participantFee
        cardTitleBackground
      }
      cardDescription
      pricing5Cta {
        cardCtaLabel
        cardCtaLink
        cardCtaColor
        cardCtaBackground
      }
      pricing5CardList {
        cardListDescription
      }
    }
  }
`;

const StyledPricing5 = styled.div`
  padding-top: 56px;
  padding-bottom: 80px;
  background: radial-gradient(150% 100% at 50% 100%, rgb(253 203 178 / 90%) 0%, #e8dae9 30%, rgb(247 246 245) 60%);

  .Pricing5__content {
    margin-left: auto;
    margin-right: auto;
    max-width: fit-content;
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.lg}px`}) {
    padding-bottom: 64px;
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.md}px`}) {
    padding-bottom: 40px;
  }
`;

export { Pricing5 };
export type { Props as Pricing5Props };
